import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core'
import { Staff, Role } from 'app/models'
import { StaffService } from 'app/services'

import { ColorRenderComponent } from 'app/components/cell/render/color.render.component'
import { ToggleRenderComponent } from 'app/components/cell/render/toggle.render.component'
import { PasswordRenderComponent } from 'app/components/cell/render/password.render.component'

import { ColorEditorComponent } from 'app/components/cell/editor/color.editor.component'
import { PasswordEditorComponent } from 'app/components/cell/editor/password.editor.component';
import { ToggleEditorComponent } from 'app/components/cell/editor/toggle.editor.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmDialog } from 'app/components/dialog/confirm.dialog';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { LocalDataSource } from 'ng2-smart-table';
import { AppService } from 'app/app.service'

@Component({
    selector: 'table-staff',
    template: `<ng2-smart-table 
                [settings]="settings"
                [source]="source"
                (createConfirm)="handleAdd($event)"
                (editConfirm)="handleEdit($event)"
                (deleteConfirm)="handleDelete($event)"
            ></ng2-smart-table>`,
    styleUrls: ['./table.staff.component.css']
})
export class TableStaffComponent implements OnInit {

    public source: LocalDataSource
    public settings = {
        hideHeader: false,
        add: {
            confirmCreate: true,
            addButtonContent: `
            <a mat-button class="nav-link active product-add">
                <i class="material-icons">add_circle_outline</i>
                <div class="ripple-container"></div>
            </a>
            `,
            createButtonContent: `
            <i class="material-icons">check_circle_outline</i>
            <div class="ripple-container"></div>
            `,
            cancelButtonContent: `
            <i class="material-icons">highlight_off</i>
            <div class="ripple-container"></div>
            `
        },
        edit: {
            confirmSave: true,
            editButtonContent: `
            <i class="material-icons">play_circle_outline</i>
            <div class="ripple-container"></div>
            `,
            saveButtonContent: `
            <i class="material-icons">check_circle_outline</i>
            <div class="ripple-container"></div>
            `,
            cancelButtonContent: `
            <i class="material-icons">highlight_off</i>
            <div class="ripple-container"></div>
            `
        },
        delete: {
            confirmDelete: true,
            deleteButtonContent: `
            <i class="material-icons">remove_circle_outline</i>
            <div class="ripple-container"></div>
            `
        },
        columns: {
            first_name: {
                title: 'Prénom'
            },
            last_name: {
                title: 'Nom'
            },
            // phone: {
            //     title: 'Téléphone'
            // },
            // email: {
            //     title: 'e-mail'
            // },
            socialSecurityNumber: {
                width: '250px',
                title: 'Numéro Sécurité Sociale'
            },
            color: {
                title: 'Couleur',
                type: 'custom',
                filter: false,
                width: '35px',
                renderComponent: ColorRenderComponent,
                editor: {
                    type: 'custom',
                    component: ColorEditorComponent
                }
            },
            role: {
                title: 'Rôle',
                type: 'html',
                editor: {
                  type: 'list',
                  config: {
                    list: Role.list.map(role => { return {title: role.label, value: role.label}}),
                  },
                }
            },
            cash_drawer: {
                title: 'Tiroir caisse',
                type: 'custom',
                filter: false,
                renderComponent: ToggleRenderComponent,
                editor: {
                    type: 'custom',
                    component: ToggleEditorComponent
                }
            },
            reduction: {
                title: 'Réduction',
                type: 'custom',
                filter: false,
                renderComponent: ToggleRenderComponent,
                editor: {
                    type: 'custom',
                    component: ToggleEditorComponent
                }
            },
            remove_order: {
                title: 'Suppression Commandes',
                type: 'custom',
                filter: false,
                renderComponent: ToggleRenderComponent,
                editor: {
                    type: 'custom',
                    component: ToggleEditorComponent
                }
            },
            remove_quantity: {
                title: 'Suppression Produit',
                type: 'custom',
                filter: false,
                renderComponent: ToggleRenderComponent,
                editor: {
                    type: 'custom',
                    component: ToggleEditorComponent
                }
            },
            payment: {
                title: 'Paiement',
                type: 'custom',
                filter: false,
                renderComponent: ToggleRenderComponent,
                editor: {
                    type: 'custom',
                    component: ToggleEditorComponent
                }
            },
            last_print: {
                title: 'Derniers encaissements',
                type: 'custom',
                filter: false,
                renderComponent: ToggleRenderComponent,
                editor: {
                    type: 'custom',
                    component: ToggleEditorComponent
                }
            },
            login: {
                title: 'Identidiant'
            },
            password: {
                title: 'Mot de passe',
                filter: false,
                type: 'custom',
                renderComponent: PasswordRenderComponent,
                editor: {
                    type: 'custom',
                    component: PasswordEditorComponent
                }
            },
        }
    }
    
    @Input()
    public staffs: Array<Staff>

    @Output()
    public onCreate: EventEmitter<any> = new EventEmitter
    @Output()
    public onEdit: EventEmitter<any> = new EventEmitter
    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter

    constructor(
        private _StaffService: StaffService,
        private _LoaderService: NgxUiLoaderService,
        private _Dialog: MatDialog,
        private _ToasterService: ToastrService
    ) { }


    public ngOnInit(): void {
        this.source = new LocalDataSource(this.staffs.map(staff => {
            staff.role = this.getRole(staff.role)
            return staff
        }))
    }
    private getRole(code: string): string {
        let role = Role.list.filter(data => data.value === code)
        return (role.length > 0) 
          ? role[0].label
          : "Debug"
    }
    private getReverseRole(label: string): string {
        let role = Role.list.filter(data => data.label === label)
        return (role.length > 0) 
          ? role[0].value
          : "DEBUG"
    }

    public async handleAdd($event): Promise<void> {
        try {
            this._LoaderService.start()
            let staff = {
                ...$event.newData,
                role: this.getReverseRole($event.newData.role)
            }
            let res = await this._StaffService.add(staff)
            $event.newData.staff_id = res.lastInsertId
            await $event.confirm.resolve($event.newData)
            this.onCreate.emit($event.newData)
            this._LoaderService.stop()
            this._ToasterService.success("Ajout de l'équipier effectué.")
            return Promise.resolve()
        } catch (error) {
            console.error("TableStaffComponent::handleAdd", error)
            this._LoaderService.stop()
            if (error.json().code === "0x1007") this._ToasterService.warning(`Vous n'êtes pas autorisé à effectuer cette action`)
            else this._ToasterService.error("Erreur lors de l'ajout de l'équipier.")
            return Promise.reject(error)
        }
    }

    public async handleEdit($event): Promise<void> {
        try {
            this._LoaderService.start()
            let staff = {
                ...$event.newData,
                role: this.getReverseRole($event.newData.role)
            }
            await this._StaffService.edit($event.data.staff_id, staff)
            await $event.confirm.resolve()
            this.onEdit.emit($event.newData)
            this._LoaderService.stop()
            this._ToasterService.success("Modification de l'équipier effectué.")
            return Promise.resolve()
        } catch (error) {
            console.error("TableStaffComponent::handleEdit", error)
            this._LoaderService.stop()
            if (error.json().code === "0x1007") this._ToasterService.warning(`Vous n'êtes pas autorisé à effectuer cette action`)
            else this._ToasterService.error("Erreur lros de la modification de l'équipier.")
            return Promise.reject(error)
        }
    }
    
    public async handleDelete($event): Promise<void> {
        try {
            let dialog = this._Dialog.open(ConfirmDialog, {width: '400px'})
            let result = await dialog.afterClosed().toPromise()
            if (!result) return
            this._LoaderService.start()
            await this._StaffService.delete($event.data.staff_id)
            await $event.confirm.resolve()
            this.onDelete.emit($event.index)
            this._LoaderService.stop()
            this._ToasterService.success("Suppression de l'équipier effectué.")
            return Promise.resolve()
        } catch (error) {
            console.error("TableStaffComponent::handleDelete", error)
            this._LoaderService.stop()
            if (error.json().code === "0x1007") this._ToasterService.warning(`Vous n'êtes pas autorisé à effectuer cette action`)
            else this._ToasterService.error("Erreur lors de la suppression de l'équipier.")
            return Promise.reject(error)
        }
    }
    
}